export { default } from "./getLanguageText";
